module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ka-Lb.bd75431a.png";